// Shared retry/timeout wrapper for the progression endpoints, which are slow on a
// cold backend (first request after a deploy rebuilds cached standard descriptions)
// and would otherwise surface a single transient failure as a permanent error.

export const REQUEST_TIMEOUT_MS = 30000;
export const MAX_REQUEST_ATTEMPTS = 3;

function delay(ms) {
  return new Promise((resolve) => {
    window.setTimeout(resolve, ms);
  });
}

export function fetchWithTimeout(createRequest, timeoutMs = REQUEST_TIMEOUT_MS) {
  let timeoutId;
  return Promise.race([
    createRequest(),
    new Promise((_, reject) => {
      timeoutId = window.setTimeout(() => reject(new Error('Request timed out')), timeoutMs);
    }),
  ]).finally(() => window.clearTimeout(timeoutId));
}

export async function fetchWithRetry(createRequest, {
  attempts = MAX_REQUEST_ATTEMPTS,
  timeoutMs = REQUEST_TIMEOUT_MS,
} = {}) {
  let lastError;

  for (let attempt = 0; attempt < attempts; attempt += 1) {
    try {
      return await fetchWithTimeout(createRequest, timeoutMs);
    } catch (error: any) {
      lastError = error;
      if (attempt < attempts - 1) {
        await delay(600 * (attempt + 1));
      }
    }
  }

  throw lastError;
}
